import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BentoModule } from '@bento/bento-ng';
import { NgbModule, NgbActiveModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { BentoD3Module } from '@bento/bento-ng-d3';'@bento/bento-ng-datamap';
import { BentoTransferboxModule } from '@bento/bento-ng-transferbox';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { AppInitService } from './app.init';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppEffects } from './store/effects/app.effects';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { LayoutModule } from './layout/layout.module';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as reducer from './store/reducers/app.reducer';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BfmModule } from '@bento/bfm-ng';
import { DatePipe } from '@angular/common';
import { Extensions } from './shared/extensions';
import { NgbDateGlobalParserFormatter } from './core/services/utils/Date/parser-formatter/ngb-date-global-parser-formatter';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CanDeactivateGuard } from './shared/guards/can-deactivate-guard.service';
import { GfrEventsAdministrationModule } from './modules/gfr-events-administration/gfr-events-administration.module';
export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    A11yModule,
    BidiModule,
    WjInputModule,
    WjGridModule,
    WjGridFilterModule,
    WjGridGrouppanelModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BfmModule,
    BentoModule,
    BentoD3Module,
    BentoFlexGridControlModule,
    BentoTransferboxModule,
    AppRoutingModule,
    FormsModule,
    BentoModule,
    BentoD3Module,
    BentoTransferboxModule,
    BentoFlexGridControlModule,
    WjGridModule,
    WjInputModule,
    WjGridFilterModule,
    WjGridGrouppanelModule,
    LayoutModule,
    CoreModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot({}
    ),
    NgIdleKeepaliveModule.forRoot(),
    StoreModule.forFeature('permission', reducer.reducer),
    EffectsModule.forRoot([AppEffects]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    GfrEventsAdministrationModule
  ],
  bootstrap: [AppComponent],
  providers: [NgbActiveModal, DatePipe, Extensions, { provide: NgbDateParserFormatter, useClass: NgbDateGlobalParserFormatter }, CanDeactivateGuard]
})
export class AppModule { }
